import React, { useState, useEffect } from "react";
import {
  Container,
  Form,
  Button,
  Row,
  Col,
  Dropdown,
  DropdownButton,
  ButtonGroup,
  InputGroup,
  ButtonToolbar,
  Modal,
  Card,
  Accordion,
} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPencil,
  faLightbulb,
  faTimes,
  faSave,
  faCheckCircle,
} from "@fortawesome/free-solid-svg-icons";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { initializeApp } from "firebase/app";
import {
  getFirestore,
  collection,
  addDoc,
  where,
  query,
  getDocs,
  doc,
  updateDoc,
} from "firebase/firestore";
import { Timestamp } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { useAuthState } from "react-firebase-hooks/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBBzepSPN2wdZfvan5GgyeeIREAV6k5BaU",
  authDomain: "loftie-4f472.firebaseapp.com",
  databaseURL: "https://loftie-4f472.firebaseio.com",
  projectId: "loftie-4f472",
  storageBucket: "loftie-4f472.appspot.com",
  messagingSenderId: "302939981606",
  appId: "1:302939981606:web:7fcb10ed6fe46fa437a3e7",
  measurementId: "G-L8VGQXX28P",
};

const firebaseApp = initializeApp(firebaseConfig);
const auth = getAuth(firebaseApp);

function NotificationCenter() {
  const [user, userLoading] = useAuthState(auth);
  const [subject, setSubject] = useState("");
  const [content1, setContent1] = useState("");
  const [content2, setContent2] = useState("");
  const [linkTitle, setLinkTitle] = useState("");
  const [linkUrl, setLinkUrl] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const [sendAtDate, setSendAtDate] = useState(new Date());
  const [selectedUser, setSelectedUser] = useState("");
  const [includeLink, setIncludeLink] = useState(false);
  const [includeImage, setIncludeImage] = useState(false);
  const [paragraphCount, setParagraphCount] = useState(1);
  const [contentSaved, setContentSaved] = useState(false);
  const [notificationType, setNotificationType] = useState("");
  const [showFlowFields, setShowFlowFields] = useState(false);
  const [flowName, setFlowName] = useState("");
  const [flowTrigger, setFlowTrigger] = useState("");
  const [hasTimeDelay, setHasTimeDelay] = useState(false);
  const [timeDelayInterval, setTimeDelayInterval] = useState("");
  const [timeDelayUnit, setTimeDelayUnit] = useState("");
  const [showEmail, setShowEmail] = useState(false);
  const [previewUserEmail, setPreviewUserEmail] = useState("");
  const [previewMessage, setPreviewMessage] = useState(null);
  const [allowSave, setAllowSave] = useState(false);
  const [newMessage, setNewMessage] = useState(false);
  const [editMessage, setEditMessage] = useState(false);
  const [messages, setMessages] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [editedData, setEditedData] = useState({});
  const [showEditingForm, setShowEditingForm] = useState(false);

  const users = [
    "All",
    "Loftie+",
    "New accounts",
    "New lamp",
    "New clock",
    "Non Loftie+",
    "All Lamp Users",
    "All Clock Users",
  ];

  useEffect(() => {
    // Only fetch messages if user is authenticated
    if (!user) return;

    const getMessages = async () => {
      try {
        const querySnapshot = await getDocs(
          collection(getFirestore(), "app-messages")
        );

        const messagesData = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          subject: doc.data().subject,
          content: doc.data().content,
          link: doc.data().link || null,
          sendAt: doc.data().sendAt?.toDate() || null,
          imageUrl: doc.data().imageUrl || "",
          messageSent: doc.data().sent || false,
        }));

        setMessages(messagesData);
      } catch (error) {
        console.error("Error fetching messages: ", error);
      }
    };

    getMessages();
  }, [user]);

  const handleEditClick = (msg) => {
    setShowEditingForm(!showEditingForm);
    setEditingId(msg.id);
    setEditedData({ ...msg });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!allowSave && !previewMessage) {
      return;
    }

    const userMapping = {
      All: "all",
      "Loftie+": "loftiePlus",
      "New accounts": "newAccount",
      "New lamp": "newLamp",
      "New clock": "newClock",
      "Non Loftie+": "noLoftiePlus",
      "All Lamp Users": "allLamps",
      "All Clock Users": "allClocks",
    };

    const messageData = {
      subject,
      content: paragraphCount === 1 ? [content1] : [content1, content2],
      users: userMapping[selectedUser] || "all",
      createdAt: Timestamp.fromDate(new Date()),
      sendAt: Timestamp.fromDate(sendAtDate),
      type: notificationType.toLowerCase(),
    };
    if (includeLink) {
      messageData.link = {
        title: linkTitle,
        url: linkUrl,
      };
    }

    if (includeImage) {
      messageData.imageUrl = imageUrl;
    }
    if (notificationType == "Campaign") {
      messageData.sent = false;
    }
    if (notificationType == "Flow") {
      messageData.timeDelay = {
        timeDelayInterval: parseInt(timeDelayInterval),
        timeDelayUnit: timeDelayUnit,
        flowTrigger: flowTrigger,
      };
      messageData.hasTimeDelay = hasTimeDelay;
    }

    if (previewMessage) {
      messageData.previewUserEmail = previewUserEmail;
      messageData.previewMessage = previewMessage;
    }

    try {
      const messageDocRef = await addDoc(
        collection(getFirestore(firebaseApp), "app-messages"),
        messageData
      );
      if (!previewMessage) {
        setShowEmail(notificationType === "Flow");
      }
      setContentSaved(true);
      if (previewMessage) {
        sendPreviewMessage(messageDocRef.id);
      }
    } catch (error) {
      console.error("Error adding document: ", error);
    }
  };

  function determineShowFields(selectedValue) {
    console.log("determing notification type", selectedValue);
    if (selectedValue == "Flow") {
      setShowFlowFields(true);
    } else {
      setShowFlowFields(false);
    }
  }

  const sendEmailFlowInformation = () => {
    const email = "mandy@example.com"; // Replace with Mandy's email
    const subject = encodeURIComponent("Flow Notification Saved");
    const body = encodeURIComponent(
      `Hi girly,\n\nThere is a new flow notification. Here are the details:\n\nFlow Name: ${flowName}\nFlow Trigger: ${flowTrigger}\n\nBest,\nYour App`
    );

    const mailtoLink = `https://mail.google.com/mail/?view=cm&fs=1&to=${email}&su=${subject}&body=${body}`;

    window.open(mailtoLink, "_blank");
    setShowEmail(false);
  };

  const sendPreviewMessage = async (messageId) => {
    const inboxData = {
      addAt: Timestamp.now(),
      isRead: false,
      messageRef: doc(getFirestore(firebaseApp), "app-messages", messageId),
      showMessage: true,
    };
    if (previewUserEmail != "") {
      const q = query(
        collection(getFirestore(firebaseApp), "users"),
        where("email", "==", previewUserEmail)
      );
      const userDocs = await getDocs(q);
      if (!userDocs.empty) {
        const userDoc = userDocs.docs[0];
        const userDocRef = userDoc.ref;
        const docData = userDoc.data();
        const inboxMessages = docData.inboxMessages || [];
        inboxMessages.unshift(inboxData);
        await updateDoc(userDocRef, { inboxMessages });
      }
    }

    setShowEmail(true);
  };

  const setPreviewMessageValues = (value) => {
    const isPreview = value === "Yes";
    setPreviewMessage(isPreview);
    setAllowSave(!isPreview);
  };

  const handleChange = (field, value) => {
    setEditedData((prev) => ({
      ...prev,
      [field]: value,
      ...(field === "sendAt" && { messageSent: false }), // Reset sent if sendAt is changed
    }));
  };

  console.log("edited data", editedData);

  if (userLoading) {
    return (
      <Container className="d-flex justify-content-center align-items-center mt-5">
        <h3>Loading...</h3>
      </Container>
    );
  }

  if (!user) {
    return (
      <Container className="d-flex justify-content-center align-items-center mt-5">
        <h3>Authentication Required</h3>
      </Container>
    );
  }

  return (
    <Container className="mt-4">
      <Spacer height={45} />
      <h1 className="text-center mb-4" style={{ color: "#F0D6B5" }}>
        Notification Center
      </h1>
      <Row className="mt-4 g-4 justify-content-center">
        <Col md={5}>
          <Card
            className="text-center"
            onClick={() => {
              setNewMessage(!newMessage);
              setEditMessage(false);
            }}
          >
            <Card.Body>
              <FontAwesomeIcon icon={faLightbulb} size="3x" style={iconStyle} />
              <Card.Title>New Message</Card.Title>
            </Card.Body>
          </Card>
        </Col>
        <Col md={5}>
          <Card
            className="text-center"
            onClick={() => {
              setEditMessage(!editMessage);
              setNewMessage(false);
            }}
          >
            <Card.Body>
              <FontAwesomeIcon icon={faPencil} size="3x" style={iconStyle} />
              <Card.Title>Edit Messages</Card.Title>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      {newMessage && (
        <Form
          onSubmit={handleSubmit}
          className="p-4 bg-white rounded shadow-lg w-75 mx-auto"
        >
          <h6>Create new user notification</h6>
          <Col>
            <Form.Label className="text-dark">Message Type</Form.Label>
            <DropdownButton
              id="dropdown-custom-components"
              title={notificationType || "Select notification type"}
              onSelect={(selectedValue) => {
                console.log("Selected value:", selectedValue);
                setNotificationType(selectedValue);
                determineShowFields(selectedValue);
              }}
              variant="outline-secondary"
            >
              <Dropdown.Item eventKey="Flow">Flow</Dropdown.Item>
              <Dropdown.Item eventKey="Campaign">Campaign</Dropdown.Item>
            </DropdownButton>
          </Col>
          {showFlowFields && (
            <Row>
              <Col sm={4}>
                <Form.Group controlId="flowName" className="mb-3">
                  <Form.Label className="text-dark">Flow Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter flow name"
                    value={flowName}
                    onChange={(e) => setFlowName(e.target.value)}
                    className="bg-white text-dark"
                  />
                </Form.Group>
              </Col>
              <Col sm={4}>
                <Form.Group controlId="flowTrigger" className="mb-3">
                  <Form.Label className="text-dark">Flow Trigger</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter flow trigger"
                    value={flowTrigger}
                    onChange={(e) => setFlowTrigger(e.target.value)}
                    className="bg-white text-dark"
                  />
                </Form.Group>
              </Col>
              <Col sm={5}>
                <Form.Check
                  type="checkbox"
                  label="Has Time Delay"
                  checked={hasTimeDelay}
                  onChange={(e) => setHasTimeDelay(e.target.checked)}
                  className="custom-checkbox"
                />
                {hasTimeDelay && (
                  <Form.Group controlId="timeDelay" className="mb-3">
                    <Form.Label className="text-dark">Time Delay</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="number"
                        placeholder="Enter number"
                        value={timeDelayInterval}
                        onChange={(e) => setTimeDelayInterval(e.target.value)}
                        className="bg-white text-dark"
                      />
                      <ButtonToolbar>
                        <ButtonGroup className="ms-2">
                          <Button
                            variant={
                              timeDelayUnit === "days" ? "primary" : "secondary"
                            }
                            onClick={() => setTimeDelayUnit("days")}
                          >
                            Day
                          </Button>
                          <Button
                            variant={
                              timeDelayUnit === "weeks"
                                ? "primary"
                                : "secondary"
                            }
                            onClick={() => setTimeDelayUnit("weeks")}
                          >
                            Week
                          </Button>
                          <Button
                            variant={
                              timeDelayUnit === "months"
                                ? "primary"
                                : "secondary"
                            }
                            onClick={() => setTimeDelayUnit("months")}
                          >
                            Month
                          </Button>
                        </ButtonGroup>
                      </ButtonToolbar>
                    </InputGroup>
                  </Form.Group>
                )}
              </Col>
            </Row>
          )}

          <br />
          <Form.Group controlId="subject" className="mb-3">
            <Form.Label className="text-dark">Subject</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter subject"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              className="bg-white text-dark"
            />
          </Form.Group>

          {/* Content Type - Number of Paragraphs */}
          <Form.Group controlId="contentType" className="mb-3">
            <Form.Label className="text-dark">Number of Paragraphs</Form.Label>
            <Row>
              <Col sm="auto">
                <Form.Check
                  type="radio"
                  label="1 Paragraph"
                  name="paragraphCount"
                  value="1"
                  checked={paragraphCount === 1}
                  onChange={() => setParagraphCount(1)}
                  className="custom-radio"
                />
              </Col>
              <Col sm="auto">
                <Form.Check
                  type="radio"
                  label="2 Paragraphs"
                  name="paragraphCount"
                  value="2"
                  checked={paragraphCount === 2}
                  onChange={() => setParagraphCount(2)}
                  className="custom-radio"
                />
              </Col>
            </Row>
          </Form.Group>

          <Form.Group controlId="content" className="mb-3">
            <Form.Label className="text-dark">Content</Form.Label>
            {paragraphCount === 1 ? (
              <Form.Control
                as="textarea"
                rows={3}
                placeholder="Enter first paragraph"
                value={content1}
                onChange={(e) => setContent1(e.target.value)}
                className="bg-white text-dark"
              />
            ) : (
              <>
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="Enter first paragraph"
                  value={content1}
                  onChange={(e) => setContent1(e.target.value)}
                  className="bg-white text-dark mb-3"
                />
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="Enter second paragraph"
                  value={content2}
                  onChange={(e) => setContent2(e.target.value)}
                  className="bg-white text-dark"
                />
              </>
            )}
          </Form.Group>

          {/* Link Title and URL with Checkbox */}
          <Form.Group controlId="link" className="mb-3">
            <div style={{ display: "inline-block", marginRight: "10px" }}>
              <Form.Check
                type="checkbox"
                label="Include Link"
                checked={includeLink}
                onChange={(e) => setIncludeLink(e.target.checked)}
                className="custom-checkbox"
              />
            </div>
            {includeLink && (
              <>
                <Row>
                  <Col>
                    <Form.Control
                      type="text"
                      placeholder="Link Title"
                      value={linkTitle}
                      onChange={(e) => setLinkTitle(e.target.value)}
                      className="bg-white text-dark"
                    />
                  </Col>
                  <Col>
                    <Form.Control
                      type="url"
                      placeholder="Link URL"
                      value={linkUrl}
                      onChange={(e) => setLinkUrl(e.target.value)}
                      className="bg-white text-dark"
                    />
                  </Col>
                </Row>
              </>
            )}
          </Form.Group>

          <Form.Group controlId="image" className="mb-3">
            <div style={{ display: "inline-block", marginRight: "10px" }}>
              <Form.Check
                type="checkbox"
                label="Include Image"
                checked={includeImage}
                onChange={(e) => setIncludeImage(e.target.checked)}
                className="custom-checkbox"
              />
            </div>
            {includeImage && (
              <Form.Control
                type="url"
                placeholder="Enter image URL"
                value={imageUrl}
                onChange={(e) => setImageUrl(e.target.value)}
                className="bg-white text-dark"
              />
            )}
          </Form.Group>

          <Form.Group controlId="userDate" className="mb-3">
            <Row>
              <Col>
                <Form.Label className="text-dark">Select User</Form.Label>
                <DropdownButton
                  id="dropdown-custom-components"
                  title={selectedUser || "Select a user"}
                  onSelect={(selectedValue) => setSelectedUser(selectedValue)}
                  variant="outline-secondary"
                >
                  {users.map((user, index) => (
                    <Dropdown.Item key={index} eventKey={user}>
                      {user}
                    </Dropdown.Item>
                  ))}
                </DropdownButton>
              </Col>
              {!showFlowFields && (
                <Col>
                  <Row>
                    <Form.Label className="text-dark">Schedule Time</Form.Label>
                    <DatePicker
                      selected={sendAtDate}
                      onChange={(date) => setSendAtDate(date)}
                      dateFormat="MMMM d, yyyy"
                      className="form-control"
                      style={{ backgroundColor: "#fff", color: "#000" }}
                    />
                  </Row>
                </Col>
              )}
            </Row>
          </Form.Group>
          <Form.Group controlId="sendPreview" className="mb-3">
            {/* Send Preview Dropdown */}
            <Col xs="auto">
              <Form.Label className="text-dark">Send Preview?</Form.Label>
              <DropdownButton
                id="send-preview-dropdown"
                title={
                  previewMessage === true
                    ? "Yes"
                    : previewMessage === false
                    ? "No"
                    : "Select Yes or No"
                }
                onSelect={setPreviewMessageValues}
                variant="outline-secondary"
              >
                <Dropdown.Item eventKey="Yes">Yes</Dropdown.Item>
                <Dropdown.Item eventKey="No">No</Dropdown.Item>
              </DropdownButton>
            </Col>
            <Spacer height={10} />

            {/* Show Email Input if "Yes" is Selected */}
            {previewMessage === true && (
              <Row className="align-items-center">
                <>
                  <Col xs="auto">
                    <Form.Control
                      type="email"
                      placeholder="Enter email"
                      value={previewUserEmail}
                      onChange={(e) => setPreviewUserEmail(e.target.value)}
                    />
                  </Col>
                  <Col xs="auto">
                    <Button
                      variant="outline-primary"
                      className="mt-2 mt-md-0"
                      style={{
                        borderColor: "#F0D6B5",
                        color: "black",
                        backgroundColor: "#F0D6B5",
                      }}
                      onClick={(e) => {
                        e.preventDefault();
                        handleSubmit(e);
                      }}
                    >
                      Send Preview
                    </Button>
                  </Col>
                </>
              </Row>
            )}
          </Form.Group>
          <Button
            variant="outline"
            type="submit"
            className="w-100"
            style={{
              backgroundColor: "#F0D6B5",
              borderColor: "#F0D6B5",
              color: "black",
              opacity: allowSave ? 1 : 0.5,
            }}
            disabled={!allowSave}
          >
            {contentSaved ? "Content Saved" : "Save"}
          </Button>
        </Form>
      )}
      <div className="p-4 bg-white rounded shadow-lg w-75 mx-auto">
        <Accordion defaultActiveKey={null}>
          {messages.map((msg, index) => (
            <Accordion.Item eventKey={index.toString()} key={msg.id}>
              <Accordion.Header>{msg.subject}</Accordion.Header>
              <Accordion.Body>
                <span
                  className="ms-auto"
                  style={{
                    cursor: "pointer",
                    marginLeft: "10px",
                    color: "#F0D6B5",
                    fontWeight: "bold",
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                  }}
                  onClick={() => handleEditClick(msg)}
                >
                  <FontAwesomeIcon icon={faPencil} />
                  Edit
                </span>
                {editingId === msg.id && showEditingForm ? (
                  <>
                    <Form.Group className="mb-3">
                      <Form.Label>Subject</Form.Label>
                      <Form.Control
                        type="text"
                        value={editedData.subject}
                        onChange={(e) =>
                          handleChange("subject", e.target.value)
                        }
                      />
                    </Form.Group>

                    {/* Content */}
                    {editedData.content.map((paragraph, i) => (
                      <Form.Group
                        className="mb-3"
                        key={i}
                        style={{ textAlign: "center" }}
                      >
                        <Form.Label
                          style={{ fontSize: "0.85rem", fontWeight: "bold" }}
                        >
                          Paragraph {i + 1}
                        </Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={3}
                          value={paragraph}
                          onChange={(e) => {
                            const newContent = [...editedData.content];
                            newContent[i] = e.target.value;
                            handleChange("content", newContent);
                          }}
                        />
                      </Form.Group>
                    ))}

                    {/* Link */}
                    <Form.Group className="mb-3">
                      <Form.Label>Link</Form.Label>
                      <InputGroup>
                        <Form.Control
                          type="text"
                          placeholder="Title"
                          value={editedData.link?.title ?? ""}
                          onChange={(e) =>
                            handleChange("link", {
                              ...(editedData.link ?? {}), // Ensures link is always an object
                              title: e.target.value,
                            })
                          }
                        />

                        <Form.Control
                          type="text"
                          placeholder="URL"
                          value={editedData.link?.url ?? ""}
                          onChange={(e) =>
                            handleChange("link", {
                              ...(editedData.link ?? {}), // Prevents null errors
                              url: e.target.value,
                            })
                          }
                        />
                        <Form.Group className="mb-3">
                          <Form.Label>Image URL</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter Image URL"
                            value={editedData.imageUrl ?? ""}
                            onChange={(e) =>
                              handleChange("imageUrl", e.target.value)
                            }
                          />
                        </Form.Group>
                      </InputGroup>
                    </Form.Group>

                    {/* Send At Date (Editable Always) */}
                    <Form.Group className="mb-3">
                      <Form.Label>
                        {editedData.messageSent ? "Resend At" : "Send At"}
                      </Form.Label>
                      <DatePicker
                        selected={editedData.sendAt}
                        onChange={(date) => handleChange("sendAt", date)}
                        dateFormat="MMMM d, yyyy"
                        className="form-control"
                      />
                    </Form.Group>

                    <div className="d-flex justify-content-end">
                      <Button variant="outline-success">
                        <FontAwesomeIcon icon={faSave} /> Save
                      </Button>
                    </div>
                  </>
                ) : (
                  <>
                    <p style={labelStyle}>Content:</p>
                    {msg.content.map((p, i) => (
                      <p key={i}>{p}</p>
                    ))}
                    {msg.link &&
                    typeof msg.link === "object" &&
                    msg.link.url ? (
                      <p>
                        <strong>Link:</strong>{" "}
                        <a
                          href={msg.link.url}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {msg.link.title || "No Title"}
                        </a>
                      </p>
                    ) : (
                      <p>
                        <strong>Link:</strong> No Link Available
                      </p>
                    )}
                    {msg.imageUrl ? (
                      <div className="text-center">
                        <img
                          src={msg.imageUrl}
                          alt="Message"
                          style={{
                            maxWidth: "100%",
                            height: "auto",
                            borderRadius: "8px",
                          }}
                        />
                      </div>
                    ) : (
                      <p>No Image Available</p>
                    )}

                    <p style={labelStyle}>Send At:</p>
                    <p>{msg.sendAt ? msg.sendAt.toLocaleString() : "N/A"}</p>

                    <p style={labelStyle}>
                      <strong>Status:</strong>{" "}
                      {msg.messageSent ? (
                        <FontAwesomeIcon
                          icon={faCheckCircle}
                          style={{ color: "green" }}
                        />
                      ) : (
                        <FontAwesomeIcon
                          icon={faTimes}
                          style={{ color: "red" }}
                        />
                      )}
                    </p>
                  </>
                )}
              </Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
      </div>

      <Modal show={showEmail} onHide={() => setShowEmail(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Email Mandy</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Send Mandy an email letting her know about the new flow!
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowEmail(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={sendEmailFlowInformation}>
            Open Gmail
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
}

const iconStyle = {
  color: "#F0D6B5",
};

const fontStyle = {
  // color: "#6C757D",
  fontSize: "14px",
  fontWeight: "600",
  marginBottom: "5px",
};

const Spacer = ({ width, height }) => {
  return <div style={{ width: width || 1, height: height || 1 }}></div>;
};

const labelStyle = {
  color: "#6C757D",
  fontSize: "16px",
  fontWeight: "600",
  marginBottom: "5px",
};

export default NotificationCenter;
